/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { createRef, useEffect, useMemo } from 'react';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import './index.scss';
const isNeedPadding = (index, numPerLine) => {
    return index % numPerLine !== numPerLine - 1;
};
export default function PreviewImage(props) {
    const { data, options = {}, numPerLine = 1, padding = 1, viewRef, itemStyle, imageStyle, } = props;
    const imageRef = createRef();
    const viewer = viewRef || createRef();
    useEffect(() => {
        if (imageRef.current) {
            // @ts-ignore
            viewer.current = new Viewer(imageRef.current, options);
        }
    }, []);
    const images = useMemo(() => {
        return Array.isArray(data) ? data : [data ?? ''];
    }, [data]);
    return (
    // @ts-ignore
    React.createElement("ul", { className: 'op-preivew-image', ref: imageRef }, (images || []).map((item, index) => (React.createElement("li", { style: {
            width: `calc((100% - ${(numPerLine - 1) * padding}px) / ${numPerLine})`,
            marginRight: isNeedPadding(index, numPerLine) ? padding : 0,
            ...(itemStyle || {}),
        } },
        React.createElement("img", { src: item, alt: '\u56FE\u7247', className: 'op-preivew-image__img', style: {
                cursor: 'pointer',
                ...(imageStyle || {}),
            } }))))));
}
